import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DestroyBase } from 'src/app/components/common/ng-destroy-base';
import { AdminTabs, ModulesEnum } from 'src/app/navigation/enum';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { AppRoutingService } from '../../../app-routing.service';
import { LocalizationNavigationService } from '../services/localization-navigation-service';
import { LocalizationService } from '../services/localization-service';
import { AppStorageService } from '../../../services/app-storage.service';
import { ReportDesignerStorageService } from '../../report-designer/services/report-designer-storage.service';

/**
 * Handles app settings host component
 */
@Component({
  selector: 'app-settings-host',
  templateUrl: './app-settings-host.component.html'
})
export class AppSettingsHostComponent extends DestroyBase implements OnInit {
  /**
   * Represents the active tab.
   */
  activeTab: any;

  /**
   * Selected localization grid item
   */
  selectedLocalizationGridItem: any;

  /**
   * Indicates whether the calculation model area is active.
   */
  isCalculationModelArea = false;

  /**
   * Indicates whether the RACI template area is active.
   */
  isRaciTemplateArea = false;

  /**
   * Report designer template selected in Report designer
   */
  reportDesignerTemplate: any;

  /**
   * Indicates whether the user is an admin.
   * Default value is `false`.
   */
  protected isAdmin = false;

  /**
   * Report designer language id
   */
  reportDesignerLanguageId: any;

  /**
   * Constructor
   * @param navigationService
   * @param _ref
   * @param routingService
   */
  constructor(private navigationService: NavigationService,
    private appStorage: AppStorageService,
    private rdStorage: ReportDesignerStorageService,
    private _ref: ChangeDetectorRef,
    private routingService: AppRoutingService,
    private localizationService: LocalizationService,
    private localizationNavigationService: LocalizationNavigationService) {
    super();
  }

  /**
   * Lifecycle hook that is called after the component is initialized.
   */
  ngOnInit(): void {
    this.isAdmin = this.appStorage.userIsInRole(['Admin']);
    this.navigationService.setActiveAdminTab(AdminTabs.BusinessUnits);
    if (!this.isAdmin) {
      this.routingService.navigate(["ProjectValuation"]);
    }
    else {
      this.navigationService.activeAdminTab$.subscribe(tab => {
        this.activeTab = tab;
        this.isCalculationModelArea = this.navigationService.isCalculationModelArea();
        this.isRaciTemplateArea = this.navigationService.isRaciTemplateArea();
      })
      this.navigationService.setActiveModule(ModulesEnum.AppSettings);
      this._ref.markForCheck();
    }

    this.reportDesignerTemplate = this.rdStorage.getTemplate();
    if (this.reportDesignerTemplate) {
      this.navigationService.setActiveAdminTab(AdminTabs.LocalizationForm);
      this.localizationNavigationService.onTemplateSelected(true);
      this.activeTab = AdminTabs.LocalizationForm;
      this.reportDesignerLanguageId = this.reportDesignerTemplate.templateLanguages[this.reportDesignerTemplate.templateLanguages.length - 1];
      this.subscribeToRetriveLocalization();
    }

    this.subscribetToGridItemSelected();
  }

  /**
   * Subscribe to retrieve localization
   */
  subscribeToRetriveLocalization() {
    this.subscriptions.add(this.localizationService.getLocalizations().pipe(take(1)).subscribe(data => {
      this.selectedLocalizationGridItem = data.find(item => item.id == this.reportDesignerLanguageId);
      this._ref.markForCheck();
    }))
  }

  /**
   * Subscribe to grid item selected
   */
  subscribetToGridItemSelected() {
    this.subscriptions.add(this.localizationNavigationService._gridItemSelected.subscribe(data => {
      this.selectedLocalizationGridItem = data;
      this._ref.markForCheck();
    }))
  }

  /**
   * Returns the admin tabs enumeration.
   */
  public get adminTabs(): typeof AdminTabs {
    return AdminTabs;
  }

  /**
   * Closes the calculation model template pane.
   */
  closeCalculationModelTemplatePane(): void {
    this.activeTab = AdminTabs.CalculationModel;
  }

  /**
   * Refreshes the calculation model grid.
   */
  refreshCalculationModelGrid(): void {
    this.activeTab = AdminTabs.CalculationModelNone;
    setTimeout(() => {
      this.activeTab = AdminTabs.CalculationModel;
    });
  }

  /**
   * Closes the RACI template new pane.
   */
  closeRaciTemplateNewPane(): void {
    this.activeTab = AdminTabs.RaciTemplate;
  }

  /**
   * Refreshes the RACI template grid.
   */
  refreshRaciTemplateGrid(): void {
    this.activeTab = AdminTabs.RaciTemplateNone;
    setTimeout(() => {
      this.activeTab = AdminTabs.RaciTemplate;
    });
  }
}
